import { render } from "./LanguageSelect.vue?vue&type=template&id=4b4fbd72"
import script from "./LanguageSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/LanguageSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b4fbd72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b4fbd72', __exports__)) {
    api.reload('4b4fbd72', __exports__)
  }
  
  module.hot.accept("./LanguageSelect.vue?vue&type=template&id=4b4fbd72", () => {
    api.rerender('4b4fbd72', render)
  })

}


export default __exports__